import type { FunctionComponent, PropsWithChildren } from 'react';

import { nuc } from '../../../utils';

import Link from './Link';
import type { LinkProps } from './Link';

const MAILTO_PREFIX = 'mailto:';

export const mailToUrl = (email: string, subject?: string) =>
  `${MAILTO_PREFIX}${email}${subject ? `?subject=${nuc(subject)}` : ''}`;

export type MailToLinkProps = {
  email: string;
  subject?: string;
} & Omit<LinkProps, 'to'>;

const defaultProps: PropsWithChildren<MailToLinkProps> = {
  email: '',
  subject: undefined,
  children: null,
  openInNewTab: true,
};

/**
 * A "mailto:" Link, for starting an email in the user's email client to a given address.
 */
const MailToLink: FunctionComponent<MailToLinkProps> = ({ email, subject, ...props } = defaultProps) => (
  <Link
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    to={mailToUrl(email, subject)}
  />
);

export default MailToLink;
